import { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';

import useElasticSearch from '../../hooks/useElasticSearch';
import ExinMuiCircularProgress from '../styled/ExinMuiCircularProgress';
import ExinSelect from '../styled/ExinSelect';
import { Certification } from './StepCertification';

export type Language = {
  value: string;
  label: string;
};

/**
 * Takes a raw server response and transforms it into the data that our components prefer.
 */
function transformServerResponse(garbage: unknown): Array<Language> {
  return (garbage as any).hits.hits.reduce(
    (previous: Array<Language>, hit: any) => [
      ...previous,
      ...(hit._source.exam_languages?.map((language: any) => ({
        value: language.code,
        label: language.name,
      })) || []),
    ],
    []
  );
}

const StepCertificationLanguage: FunctionComponent<{
  certification: Certification;
  selectedLanguage: Language | null;
  setSelectedLanguage(value: Language | null): void;
}> = ({ certification, selectedLanguage, setSelectedLanguage }) => {
  const { isLoading, response: languages } = useElasticSearch(
    {
      query: {
        term: {
          post_id: parseInt(certification.value, 10),
        },
      },
      size: 10000,
      _source: ['exam_languages'],
    },
    transformServerResponse
  );

  if (isLoading) {
    return <ExinMuiCircularProgress />;
  }

  if (!languages?.length) {
    return <Trans i18nKey="messageNoCertificationLanguages">No languages found</Trans>;
  }

  return (
    <ExinSelect
      options={languages}
      value={selectedLanguage}
      // @ts-ignore
      // Something in react-select#Select demands onChange data to be `unknown`
      // TypeScript will complain, because our own data is in fact _not_ unknown.
      onChange={setSelectedLanguage}
      placeholder={<Trans i18nKey="placeholderSelect">Select</Trans>}
    />
  );
};

export default StepCertificationLanguage;
